import * as React from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import { Tooltip } from "@mui/material";
import { MstaButton, BackButton } from "../../Functions/Style/ButtonStyle";
import { MstaFontFamily } from "../../Functions/Style/MstaFont";
import { Divider } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { isTablet } from "react-device-detect";
import { useWindowDimensions } from "../../Functions/ScreenOperation/useWindowDimension";
import headimg from "../../Images/Head.jpg";
import thoraximg from "../../Images/Thorax.jpg";
import abdomenimg from "../../Images/Abdomen.jpg";
import pelvisimg from "../../Images/Pelvis.jpg";
import limbimg from "../../Images/Limb.jpg";
import MstaStyle from "../../Functions/Style/style.module.css";

export function BasicMenu() {
  const navigate = useNavigate();
  const { width, height } = useWindowDimensions();

  const menus = [
    { name: "画像診断の基礎", id: "basic" },
    { name: "正常解剖", id: "normal" },
  ];
  const BasicCards = [
    {
      title: "CT",
      image: null,
      text: "この章ではCTに関する基本的な事項についてまとめていきます。",
      url: "/basic/ct",
    },
    {
      title: "MRI",
      image: null,
      text: "この章ではMRIに関する基本的な事項についてまとめていきます。",
      url: "/basic/ct",
    },
    {
      title: "X線",
      image: null,
      text: "この章ではX線に関する基本的な事項についてまとめていきます。",
      url: "/basic/ct",
    },
  ];
  const NormalCards = [
    {
      title: "頭部",
      image: headimg,
      text: "この章では頭部の正常画像をもとに、頭部の解剖学的構造を理解しながら頭部診断時のルーティンを確認します。",
      url: "/basic/head",
    },
    {
      title: "胸部",
      image: thoraximg,
      text: "この章では胸部の正常画像をもとに、胸部の解剖学的構造を理解しながら胸部診断時のルーティンを確認します。",
      url: "/basic/thorax",
    },
    {
      title: "腹部",
      image: abdomenimg,
      text: "この章では腹部の正常画像をもとに、腹部の解剖学的構造を理解しながら腹部診断時のルーティンを確認します。",
      url: "/basic/abdomen",
    },
    {
      title: "骨盤部",
      image: pelvisimg,
      text: "この章では骨盤部の正常画像をもとに、骨盤部の解剖学的構造を理解しながら骨盤部診断時のルーティンを確認します。",
      url: "/basic/pelvis",
    },
    {
      title: "四肢",
      image: limbimg,
      text: "この章では四肢の正常画像をもとに、四肢の解剖学的構造を理解しながら四肢診断時のルーティンを確認します。",
      url: "/basic/limb",
    },
  ];

  const handleOpenLink = (url: string) => {
    const toUrl = url;
    navigate(toUrl);
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div className={MstaStyle.mstaItemCenter}>
      <Grid sx={{ mt: 3 }} display={"flex"}>
        {/* {width > 500 && isTablet === false ? (
          <Grid style={{ position: "fixed" }}>
            <Tooltip title="戻る">
              <BackButton
                variant="contained"
                sx={{ml: 3, mt: 0.5}}
                onClick={() => {
                  handleOpenLink("/");
                }}
              >
                <ArrowBackIcon />
              </BackButton>
            </Tooltip>
          </Grid>
        ) : (
          <div></div>
        )} */}

        <Container sx={{ py: 1, minHeight: "95vh" }}>
          {/* End hero unit */}
          <Typography
            gutterBottom
            align="left"
            variant="h4"
            id="normal"
            fontFamily={MstaFontFamily}
          >
            正常画像を見ながら、画像の読み方を勉強しよう
          </Typography>
          <Divider
            sx={{ borderBottomWidth: 1.5, borderColor: "black", mt: 1, mb: 4 }}
          />
          <Grid container spacing={4} mb={4}>
            {NormalCards.map((card, index) => (
              <Grid item key={index} xs={12} sm={6}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    border: 2,
                    alignItems: "center",
                  }}
                >
                  <Grid>
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Typography
                        gutterBottom
                        variant="h5"
                        fontSize={{ xs: 20, md: 30 }}
                        fontWeight={600}
                        fontFamily={MstaFontFamily}
                      >
                        {card.title}
                      </Typography>
                      <Typography
                        align="left"
                        variant="subtitle1"
                        fontSize={{ xs: 12, md: 16 }}
                        fontFamily={MstaFontFamily}
                      >
                        {card.text}
                      </Typography>
                      <Typography mt={{ md: 2 }} fontSize={{ xs: 12, md: 16 }}>
                        ✨随時更新中✨
                      </Typography>
                    </CardContent>
                    <MstaButton
                      className="lectureMenuButton"
                      size="small"
                      sx={{
                        mb: { md: 2, xs: 1 },
                        height: { xs: 30, md: 60 },
                        fontSize: { xs: 12, md: 20 },
                      }}
                      onClick={() => {
                        handleOpenLink(card.url);
                      }}
                    >
                      画像を見る
                    </MstaButton>
                  </Grid>
                  {card.image ? (
                    <CardMedia
                      component="img"
                      sx={{
                        height: { md: 180, xs: 100 },
                        width: { md: 180, xs: 100 },
                        mr: 2,
                      }}
                      image={card.image}
                      alt="random"
                    />
                  ) : (
                    <div></div>
                  )}
                </Card>
              </Grid>
            ))}
          </Grid>
          {/*
                    <Typography gutterBottom variant="h5" sx={{ mt: 5 }} id='disease'>
                        疾患一覧
                    </Typography>
                    <Grid container spacing={4}>
                        {DiseaseCards.map((card) => (
                            <Grid item key={card} xs={12} sm={6} md={4}>
                                <Card
                                    sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                                >
                                    {card.image ?
                                        <CardMedia
                                            component="img"
                                            sx={{
                                                // 16:9
                                                height: '100%',
                                                width: '100%',
                                            }}
                                            image={card.image}
                                            alt="random"
                                        /> : <div></div>}
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            {card.title}
                                        </Typography>
                                        <Typography>
                                            {card.text}
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <Button size="small" onClick={() => handleOpenLink(card.url)}>View</Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                    */}
        </Container>
      </Grid>
    </div>
  );
}
